module.exports = __webpack_public_path__ + "static/media/soils_example_1_3.e04c656c.png";


//////////////////
// WEBPACK FOOTER
// ./public/stem_soils_images/soils_example_1_3.png
// module id = 1281
// module chunks = 0